export default __webpack_public_path__ + "fb8ff880a0f1f6981a12749e0c0eff5a.jpg";